import { DatosTService } from 'src/app/services/SiicartAdm/datosT.service';
import { ConfigService } from 'src/config/config.service';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import * as AdmCamposCActions from '../../../actions/';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { CamposCService } from 'src/app/services/SiicartAdm/camposC.service';

@Injectable()
export class admCamposCEffects {

    constructor(
        private actions$: Actions,
        private camposcService: CamposCService,
        private config: ConfigService,
        private router: Router
    ) { }

    // effects go here
    @Effect()
    AdmGetCamposC$: Observable<any> = this.actions$.pipe(
        ofType(AdmCamposCActions.AdmCamposCActionTypes.GET_ADM_CAMPOSC),
        switchMap((action: AdmCamposCActions.AdmGetCamposC) => {
            return this.camposcService.ObtenerCamposCartografia(action.url)
                .pipe(
                    map((resultado: any) => {
                        return new AdmCamposCActions.AdmSuscessCamposC(resultado.fields);
                    }),
                    catchError(error => of(new AdmCamposCActions.AdmFailCamposC({ error })))
                );
        }
        )
    );

}
